import { useEffect } from 'react';
import { Cookies } from 'react-cookie';
import { useSearchParams } from 'react-router-dom';
import { getContextValue } from './globalContext';

export const USERNAME =
  /^((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))|\+\d+|\d+)$/;

export const EMAIL = /^\S+@\S+\.\S+$/;

export const OTP = /^[0-9]{6}$/;

export const DIGITS = /^\d+$/;

export const isOnlyDigits = (str) => {
  if (!str) {
    return false;
  }
  return /^\d+$/.test(str);
};

export function isSessionStorageEnabled() {
  try {
    const key = '__storage_test__';
    window.sessionStorage.setItem(key, key);
    window.sessionStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

export function base64Encode(s) {
  return btoa(unescape(encodeURIComponent(s)));
}
export function base64Decode(s) {
  return decodeURIComponent(escape(atob(s)));
}

export function usePageTitle(title = 'Login Application') {
  useEffect(() => {
    document.title = title;
  }, [title]);
}

export function useColorMode() {
  const colorModes = { dark: 'dark', light: 'light' };
  const sloPages = ['idp.slo.confirm', 'idp.slo.success', 'idp.slo.progress'];

  const pageId = getContextValue('pageId');
  const cookies = new Cookies();
  const [searchParams] = useSearchParams();

  const displaySearchParam = colorModes[searchParams.get('display')];
  const displayCookie = colorModes[cookies.get('display')];

  if (displaySearchParam) {
    cookies.set('display', displaySearchParam, { path: '/' });
    return displaySearchParam;
  }

  if (displayCookie) {
    if (sloPages.includes(pageId)) {
      return displayCookie;
    }
    cookies.remove('display', { path: '/' });
  }

  return colorModes.light;
}
